module.exports = __webpack_public_path__ + "static/media/HajjLeave.74461c1a.svg";